import { metadataUrls } from "pages/BasicSettings/Metadata/utils/metadata-urls";
import { useFormData } from "hooks/useFormData";

type SourceTypes =
    | "other"
    | "nonconformance_card"
    | "offer"
    | "contract"
    | "order"
    | "sample"
    | "cdr"
    | "container"
    | "sampling_site"
    | "sampling_point"
    | "test_plan"
    | "order_template"
    | "test"
    | "equipment"
    | "result_sheet"
    | "result"
    | "personnel"
    | "specification"
    | "position"
    | "equipment_type"
    | "sample_workflow"
    | "method"
    | "supplier"
    | "method_validation_step";

interface IUseGetTemplates {
    source: SourceTypes;
}

export const useGetTemplates = ({ source }: IUseGetTemplates) => {
    const { formData: metadataTemplates } = useFormData<ILabelValue<number>[]>({
        url: metadataUrls.templates.formData,
        params: { params: { onlyWithReleasedVersion: "True", source: source } },
    });

    return metadataTemplates;
};
